import * as React from 'react'
import * as css from './StatList.module.css'
import { useInView } from 'react-intersection-observer'
import HTag from './HTag'
import SanityBlock from './SanityBlock'
import HexPattern from './HexPattern'
import orbit from 'assets/orbit.svg'
import clsx from 'clsx'

export default function StatList({ sideBySide, heading, _rawContent, stats }) {
	const { ref, inView } = useInView()

	return (
		<section
			className={clsx(
				'py-16',
				sideBySide &&
					'mx-auto grid max-w-screen-xl gap-x-4 gap-y-12 md:grid-cols-2',
			)}
		>
			<header
				className={clsx(
					'relative',
					sideBySide && 'md:sticky-below-header self-start',
				)}
			>
				<div className="relative z-[1] mx-auto max-w-screen-lg px-4">
					<div className={clsx('max-w-[550px]', sideBySide && 'mx-auto')}>
						<HTag className="h0" {...heading} />
						<SanityBlock
							className={clsx(!heading?.text && 'text-4xl <md:text-3xl')}
							body={_rawContent}
						/>
					</div>
				</div>

				{!sideBySide && (
					<HexPattern className="-top-12 right-0 -scale-100 md:opacity-50 <md:top-0 <md:opacity-20" />
				)}
			</header>

			<dl
				ref={ref}
				className={clsx(
					'mx-auto grid max-w-screen-md grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-x-16 gap-y-12 px-4 <md:grid-cols-2 <md:gap-4',
					stats?.length >= 3 && 'md:grid-cols-2',
				)}
			>
				{stats?.map(({ number, arrow, text }, key) => (
					<div className="max-w-[250px] md:mx-auto" key={key}>
						<dt className="relative text-ft-green">
							<img
								className={clsx(inView && css.anim)}
								style={{ animationDelay: `${key * 0.2}s` }}
								src={orbit}
								alt=""
								draggable="false"
							/>
							<span
								className={clsx(
									'absolute right-0 top-1/2 flex -translate-y-1/2 items-center gap-1 text-5xl',
									css[arrow],
								)}
							>
								{number}
							</span>
						</dt>
						<dd className="technical mt-2 px-4 <md:text-sm">{text}</dd>
					</div>
				))}
			</dl>
		</section>
	)
}
